import Toastify from "toastify-js";

const buildIconNode = (icon) => {
  const node = document.createElement("span");
  node.classList.add("material-symbols-sharp");
  node.textContent = icon;
  return node;
};

const buildMessageNode = (message) => {
  const node = document.createElement("p");
  node.textContent = message;
  return node;
};

const buildContentNode = (iconNode, messageNode) => {
  const node = document.createElement("div");
  node.classList.add("notifications-toast-message__content");

  node.appendChild(iconNode);

  node.appendChild(messageNode);

  return node;
};

export default ({ text, icon }) => {
  const contentNode = buildContentNode(
    buildIconNode(icon),
    buildMessageNode(text),
  );

  Toastify({
    className: "notifications-toast-message",
    node: contentNode,
    offset: {
      x: 0,
      y: "2.4rem",
    },
    gravity: "top",
    position: "center",
    duration: 3000,
    stopOnFocus: true,
  }).showToast();
};
